/**
 * RUG SIZE GUIDE MODAL
 * Opens the existing rug size-guide UI as a native dialog and keeps it compatible
 * with the legacy full-section renderer, which otherwise intercepts the trigger.
 */
(() => {
  if (window.__rugSizeGuideModalBridge) return;
  window.__rugSizeGuideModalBridge = true;

  const getDialog = (trigger) => {
    const id = trigger && trigger.getAttribute('data-rug-dialog-open');
    const dialog = id ? document.getElementById(id) : null;
    return dialog && dialog.matches('dialog.rug-size-guide-modal') ? dialog : null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest && event.target.closest('[data-rug-dialog-open^="rug-size-guide-"]');
    if (!trigger) return;

    const dialog = getDialog(trigger);
    if (!dialog) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    dialog.__rugSizeGuideTrigger = trigger;
    if (!dialog.open) dialog.showModal();

    window.requestAnimationFrame(() => {
      dialog.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    });
  }, true);

  document.addEventListener('click', (event) => {
    const choose = event.target.closest && event.target.closest('.rug-size-guide-modal [data-rug-guide-choose]');
    if (!choose || choose.disabled) return;

    const dialog = choose.closest('dialog.rug-size-guide-modal');
    window.setTimeout(() => {
      if (dialog && dialog.isConnected && dialog.open) dialog.close();
    }, 80);
  });

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!dialog.matches || !dialog.matches('dialog.rug-size-guide-modal')) return;

    const trigger = dialog.__rugSizeGuideTrigger;
    dialog.__rugSizeGuideTrigger = null;

    if (trigger && trigger.isConnected && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
    }
  }, true);
})();
